import type { FieldSchema } from 'lorena-templates'

interface Props {
  field: FieldSchema
  value: string
  onChange: (value: string) => void
}

export function TextAreaField({ field, value, onChange }: Props) {
  return (
    <div className="field">
      <label htmlFor={field.key}>{field.label}</label>
      <textarea
        id={field.key}
        rows={4}
        placeholder={field.placeholder}
        value={value}
        onChange={(event) => onChange(event.target.value)}
      />
      {field.help && <p className="field-help">{field.help}</p>}
    </div>
  )
}
